import { Button } from 'react-bootstrap'
import { Sheet } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default function Excel(props) {

    const { onClick, tooltip_content, data = [], fileName = `${fileName}` } = props

    const exportToExcel = (jsonData, fileName) => {

        if (fileName == 'Scheduled Maintenance') {
            jsonData = jsonData.map(item => ({
                ...item,
                "EQUIPMENT DETAILS":
                    [
                        item["EQUIPMENT DETAILS"]?.equipment_name,
                        item["EQUIPMENT DETAILS"]?.makeInfo?.make_name,
                        item["EQUIPMENT DETAILS"]?.part_number
                    ]
                        .filter(Boolean)
                        .join(" ") || "",
            }))
        }

        if (fileName == 'Pricing') {
            jsonData = jsonData.map(item => ({
                ...item,
                "PRICE": item?.PRICE && item?.PRICE[0]?.equipment_price || ''
            }))
        }
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, fileName.toLowerCase() + '-' + new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).toUpperCase().replace(/ /g, "-") + '.xlsx');
    };

    return (
        <>
            <Button
                variant="outline-success"
                size='sm'
                // onClick={onClick}
                onClick={() => exportToExcel(data, fileName)}
                className='ms-1'
                data-tooltip-id='excel'
                data-tooltip-content={tooltip_content}
                data-tooltip-place="bottom"
            >
                <Sheet className='mb-1' size={14} />
            </Button>

            <Tooltip id='excel' className='bg-success' style={{ zIndex: '9', lineHeight: '1' }} />
        </>
    )
}
